import Marquee from "react-fast-marquee";

const items = [
  "Move Heal Live",
  "Online Physiotherapy",
  "Strength & Conditioning",
  "Rehab, Rebuilt",
  "ESTD 2026",
];

export default function EditorialMarquee() {
  return (
    <div
      className="border-y border-[#E5E0D8] py-5 md:py-6 select-none"
      data-testid="editorial-marquee"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-2xl md:text-3xl tracking-wide text-[#111111]/80 mx-8 md:mx-12 italic">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#8DA37F]" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
